export default function MobileDevice (props) {

    return (
        <svg className={props.className} shapeRendering="geometricPrecision" style={props.style} fill={props.fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 216">
            <path d="M 0 200 L 0 16 Q 0 0 16 0 L 112 0 Q 128 0 128 16 L 128 200 Q 128 216 112 216 L 16 216 Q 0 216 0 200 M 22 180 Q 22 184 26 184 L 102 184 Q 106 184 106 180 L 106 28 Q 106 22 100 22 L 28 22 Q 22 22 22 28 M 47 207 L 83 207 Q 90 207 90 200 Q 90 193 83 193 L 47 193 Q 40 193 40 200 Q 40 207 47 207"/>
        </svg>
    )

}